import React, { Fragment } from "react";
import { Icon, Table } from "antd";

import Photo from "./PhotoVisit";
import {
  getProductsInfos,
  addColorPropertyToProduct,
  computeDataTable,
  computeColumns,
  getKpiInfos,
  computeGskRecadrageTable
} from "./Preview.utils";
import AuthRender from "../../containers/AuthRender";
import { KPI_RECADRAGE_GSK_ID, roles } from "../../configs/constants";
import AddMedia from "./AddMedia";
import ModifyComment from "./ModifyComment";
import ModifyKpiResponses from "./ModifyKpiResponses";
export const renderVendors = vendors => {
  if (!Array.isArray(vendors) || vendors.length === 0) return null;
  //check if vendor presentation espace pro :
  if (vendors[0].email === undefined) {
    return (
      <div>
        <div style={{ fontWeight: "bold" }}>VENDEURS AYANT RECU LES IDENTIFIANTS</div>
        {vendors.map((vendor, index) => (
          <div key={index} style={{ margin: 10, width: "50%", padding: 10 }}>
            <div>
              {index + 1}. {vendor.firstname} {vendor.lastname}
            </div>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div>
      <div style={{ fontWeight: "bold" }}>FORMATIONS DES VENDEURS DU POINT DE CONTACT</div>
      {vendors.map((vendor, index) => (
        <div key={index} style={{ border: "black solid 1px", borderRadius: 4, margin: 10, width: "50%", padding: 10 }}>
          <div>
            {index + 1}. {vendor.firstname} {vendor.lastname}
          </div>
          <div style={{ marginTop: 10 }}>Email : {vendor.email || "non renseigné"}</div>
          <div>Poste : {vendor.role || "non renseigné"}</div>
          <div style={{ marginTop: 10, marginLeft: 20 }}>
            {Array.isArray(vendor.trainings) &&
              vendor.trainings.map(training => (
                <div key={training.familyId}>{`${training.family} : ${
                  training.level != "0" && training.level !== null ? "niveau " + training.level : "non formé"
                } ${training.date ? `(${training.date})` : ""}`}</div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};
export const renderMerch = kpis => {
  if (!kpis || kpis.length === 0) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      <h2 className="p-visit-detail-family p-mrg-bot-0">MERCH</h2>
      <div className="p-content-item p-al-full p-mrg-bot-l" style={{ flexDirection: "column" }}>
        {kpis.map(
          kpi =>
            Array.isArray(kpi.response) &&
            kpi.response.map(res => {
              return (
                <div
                  style={{
                    marginBottom: 20
                  }}
                >
                  {res.module_label} - {res.module_dep_label}
                  {" - "}
                  {res.module_item_label} : {res.response}
                </div>
              );
            })
        )}
      </div>
    </div>
  );
};
export const renderLocationTypeReponse = ({ locationTypeResponse: locationTypeKpis, visitId, path }) => {
  if (Array.isArray(locationTypeKpis) && locationTypeKpis.length > 0) {
    return locationTypeKpis.map((kpi, i) => {
      const kpiValues = Array.isArray(kpi.values) ? kpi.values.filter(elem => elem.indexOf("@") === -1) : [];
      if (kpi.response && kpi.response.response !== null && kpi.format && kpi.format.toLowerCase() === "boolean") {
        return (
          <div key={i}>
            <h2 className="p-visit-detail-family p-mrg-bot">{kpi.long_label}</h2>
            <div style={{ marginBottom: 15, color: "#8e8e8e" }}>{kpi.question}</div>
            <div className="p-content-item p-mrg-bot-l p-mrg-left">{kpi.response.response ? "Oui" : "Non"}</div>
          </div>
        );
      } else if (
        kpi.response &&
        kpi.response.response !== null &&
        kpi.format === "checkbox" &&
        Array.isArray(kpi.response.response)
      ) {
        return (
          <div>
            <h2 className="p-visit-detail-family p-mrg-bot">{kpi.long_label}</h2>
            <div style={{ marginBottom: 15, color: "#8e8e8e" }}>{kpi.question}</div>
            <div className="p-content-item p-mrg-bot-l p-mrg-left">
              {kpi.response.response.map(item => kpiValues[item]).join(", ")}
            </div>
          </div>
        );
      } else if (
        kpi.response &&
        kpi.response.response !== null &&
        kpi.response.response !== undefined &&
        kpi.format === "radio"
      ) {
        return (
          <div>
            <h2 className="p-visit-detail-family p-mrg-bot">{kpi.long_label}</h2>
            <div style={{ marginBottom: 15, color: "#8e8e8e" }}>{kpi.question}</div>
            <div className="p-content-item p-mrg-bot-l p-mrg-left">{kpiValues[kpi.response.response]}</div>
          </div>
        );
      } else if (
        kpi.response &&
        kpi.response.response &&
        kpi.response.response !== null &&
        kpi.response.response !== undefined
      ) {
        return (
          <div>
            <h2 className="p-visit-detail-family p-mrg-bot">{kpi.long_label}</h2>
            <div style={{ marginBottom: 15, color: "#8e8e8e" }}>{kpi.question}</div>
            <div className="p-content-item p-mrg-bot-l p-mrg-left">{kpi.response.response}</div>
            {kpi.result_format === "string" && (
              <AuthRender minRole={roles.ADMIN}>
                <ModifyComment visitId={visitId} path={path} kpi={kpi} />
              </AuthRender>
            )}
          </div>
        );
      } else {
        return (
          <div>
            {kpi.result_format === "string" && (
              <AuthRender minRole={roles.ADMIN}>
                <h2 className="p-visit-detail-family p-mrg-bot">{kpi.long_label}</h2>
                <div style={{ marginBottom: 15, color: "#8e8e8e" }}>{kpi.question}</div>
                <div className="p-content-item p-mrg-bot-l p-mrg-left">[NON RENSEIGNE]</div>
                <ModifyComment visitId={visitId} path={path} kpi={kpi} />
              </AuthRender>
            )}
          </div>
        );
      }
    });
  }

  return null;
};

export const renderEndVisitStatement = ({ currentVisit }) => {
  const kpisArray = currentVisit.end_visit_statement.kpis;
  if (kpisArray && kpisArray.length && kpisArray.length > 0) {
    for (let j = 0; j < kpisArray.length; j++) {
      const kpi = kpisArray[j];
      if (kpi.response) {
        return {
          item: (
            <Fragment>
              <div className="p-visit-detail-location p-mrg-top p-mrg-bot p-brd-bot p-pdg-bot-s">{kpi.long_label}</div>
              <h2 className="p-page-subtitle p-mrg-bot-s">{kpi.question}</h2>
              <div className="p-content-item p-mrg-bot-l" style={{ whiteSpace: "pre-wrap" }}>
                {kpi.response.response}
              </div>
              {kpi.result_format === "string" && (
                <AuthRender minRole={roles.ADMIN}>
                  <ModifyComment visitId={currentVisit._id} isInEndVisitStatement={true} kpi={kpi} />
                </AuthRender>
              )}
            </Fragment>
          ),
          header: kpi.long_label
        };
      } else {
        return {
          item: (
            <Fragment>
              {kpi.result_format === "string" && (
                <AuthRender minRole={roles.ADMIN}>
                  <div className="p-visit-detail-location p-mrg-top p-mrg-bot p-brd-bot p-pdg-bot-s">
                    {kpi.long_label}
                  </div>
                  <h2 className="p-page-subtitle p-mrg-bot-s">{kpi.question}</h2>
                  <div className="p-content-item p-mrg-bot-l">[NON RENSEIGNE]</div>
                  <ModifyComment visitId={currentVisit._id} isInEndVisitStatement={true} kpi={kpi} />
                </AuthRender>
              )}
            </Fragment>
          ),
          header: kpi.long_label
        };
      }
    }
  }
};
export const renderMedia = ({ medias = [], currentVisit = {}, path = {} }) => {
  const mediasToRenderOther = [];
  const mediasToRenderBefore = [];
  const mediasToRenderAfter = [];

  for (let i = 0; i < medias.length; i++) {
    const media = medias[i];
    if (media.type === "Photo" && media.response && media.response.url) {
      if (media.response.before) {
        mediasToRenderBefore.push(
          <Photo key={i} pdc_label={currentVisit.pdc_label} visit_end_date={currentVisit.endDate} media={media} />
        );
      } else if (media.response.after) {
        mediasToRenderAfter.push(
          <Photo key={i} pdc_label={currentVisit.pdc_label} visit_end_date={currentVisit.endDate} media={media} />
        );
      } else {
        mediasToRenderOther.push(
          <Photo key={i} pdc_label={currentVisit.pdc_label} visit_end_date={currentVisit.endDate} media={media} />
        );
      }
    }
  }

  if (mediasToRenderBefore.length + mediasToRenderAfter.length + mediasToRenderOther === 0) {
    return null;
  }

  return (
    <div>
      <h2 className="p-page-subtitle p-mrg-bot-s">MEDIAS</h2>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <h3 style={{ fontWeight: "bold" }}>Photos avant action</h3>
          {mediasToRenderBefore.length > 0 ? (
            mediasToRenderBefore
          ) : (
            <div style={{ margin: 10 }}>
              <Icon type="stop" />
              <span style={{ marginLeft: 10 }}>(Aucune photo "avant")</span>
            </div>
          )}
          <AuthRender minRole={roles.ADMIN}>
            <AddMedia visitId={currentVisit._id} before={true} visitPath={path} />
          </AuthRender>
        </div>
        <div>
          <h3 style={{ fontWeight: "bold" }}>Photos après action</h3>
          {mediasToRenderAfter.length > 0 ? (
            mediasToRenderAfter
          ) : (
            <div style={{ margin: 10 }}>
              <Icon type="stop" />
              <span style={{ marginLeft: 10 }}>(Aucune photo "après")</span>
            </div>
          )}
          <AuthRender minRole={roles.ADMIN}>
            <AddMedia visitId={currentVisit._id} after={true} visitPath={path} />
          </AuthRender>
        </div>
        <div>
          <h3 style={{ fontWeight: "bold" }}>Autres</h3>
          {mediasToRenderOther.length > 0 ? (
            mediasToRenderOther
          ) : (
            <div style={{ margin: 10 }}>
              <Icon type="stop" />
              <span style={{ marginLeft: 10 }}>(Aucune photo "autre")</span>
            </div>
          )}
          <AuthRender minRole={roles.ADMIN}>
            <AddMedia visitId={currentVisit._id} visitPath={path} />
          </AuthRender>
        </div>
      </div>
    </div>
  );
};

export const renderFamily = ({ family = {}, familiesList = [], path, currentVisit = {} }) => {
  const { locationId, locationTypeId } = path;
  const { responseProducts, labelsOfKpisProducts: columnsTitles } = family;

  if (Array.isArray(responseProducts) && responseProducts.length === 0) return null;

  const familyInfo = familiesList.find(f => family.familyId === f.family_id) || {};

  const familyLabel = familyInfo.family_label || "FAMILLE INCONNUE";

  const columnsQuestion = columnsTitles.map((columnsTitle, i) => ({
    title: columnsTitle,
    dataIndex: columnsTitle || "-",
    render: (response, record, index) => {
      const product = getProductsInfos(record.product, currentVisit, locationId, locationTypeId);
      const rowStyle = addColorPropertyToProduct(product, currentVisit.client_id);
      const { kpiFormat, kpiId } = getKpiInfos({ visit: currentVisit, path, question: columnsTitle });

      return (
        <div key={index} style={rowStyle}>
          {response}
          <AuthRender minRole={roles.ADMIN}>
            {
              <ModifyKpiResponses
                record={{
                  ...record,
                  [columnsTitle]: { response, kpiFormat, kpiId },
                  path,
                  visitId: currentVisit._id,
                  itemId: record.product
                }}
                question={columnsTitle}
              />
            }
          </AuthRender>
        </div>
      );
    }
  }));
  const columns = [{ title: "Références", dataIndex: "product_label", key: "product" }].concat(columnsQuestion);

  return (
    <div>
      <div className="p-visit-detail-family p-mrg-bot-0">{familyLabel}</div>
      <div className="p-mrg-bot-l  p-mrg-top-s p-mrg-top-s">
        <Table
          rowKey={record => `${record.product}`}
          columns={columns}
          dataSource={responseProducts}
          pagination={false}
          locale={{
            emptyText: "Aucune donnée"
          }}
        />
      </div>
    </div>
  );
};

export const renderTableKpis = ({
  data,
  name = "",
  source = "",
  itemListWithDuplication = [],
  path = {},
  visitId = ""
}) => {
  if (Array.isArray(data) && data.length === 0) return null;

  const kpiGSKRecadrage = data.filter(k => k.id === KPI_RECADRAGE_GSK_ID);

  const tableGSKRecadrage = computeGskRecadrageTable({
    data: kpiGSKRecadrage
  });

  const table = computeDataTable({ data, itemListWithDuplication, source, path, visitId });

  if (Array.isArray(table) && table.length === 0) return null;
  const columns = computeColumns(name, data);
  const columnsRecadrage = computeColumns(name, kpiGSKRecadrage);

  return (
    <div>
      {kpiGSKRecadrage.length === 0 ? (
        <div>
          <h2 className="p-visit-detail-family p-mrg-bot-0">KPI {name.toUpperCase()}</h2>
          <div className="p-mrg-bot-l p-mrg-top-s">
            <Table
              rowKey={record => `${record.itemId}+${Math.random()}`}
              columns={columns}
              dataSource={table}
              pagination={false}
              locale={{
                emptyText: "Aucune donnée"
              }}
            />
          </div>
        </div>
      ) : (
        <div>
          <h2 className="p-visit-detail-family p-mrg-bot-0">KPI {name.toUpperCase()}</h2>
          <div className="p-mrg-bot-l p-mrg-top-s">
            <Table
              rowKey={record => `${record.itemId}+${Math.random()}`}
              columns={columnsRecadrage}
              dataSource={tableGSKRecadrage}
              pagination={false}
              locale={{
                emptyText: "Aucune donnée"
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// src/components/visit/Preview.render.js